// extracted by mini-css-extract-plugin
export default {"body":"Prolongate_body__0viOn","block":"Prolongate_block__-djvm","error":"Prolongate_error__3Ak2T","title":"Prolongate_title__ON75n","content":"Prolongate_content__FquAO"};